import {
	AfterViewInit,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnDestroy,
	Output,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import { FormioCustomComponent, FormioComponent, CHARTSTYPES, FormioLoader } from 'dp-formio';

@Component({
	selector: 'app-charts-wrapper',
	templateUrl: './charts-wrapper.component.html',
	// styleUrls: ['./charts-wrapper.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ChartsWrapperComponent
	implements FormioCustomComponent<any>, OnChanges, AfterViewInit, OnDestroy
{
	@ViewChild(FormioComponent) formComponent: FormioComponent;

	dir: 'rtl' | 'ltr';
	@Input() required: boolean;
	@Input() value: any = {};
	@Output() valueChange = new EventEmitter<any>();
	@Input() disabled: boolean;
	@Input() viewOnly: boolean;
	@Input() data: any;
	@Input() customOptions: any;
	@Input() formioComponent: any;

	chartType: string;
	chartData: any = {};
	chartLabels: any[] = [];
	isFOView: boolean;
	isBOView: boolean;
	addDelay: boolean;
	show: boolean;

	public get CHARTTYPE(): typeof CHARTSTYPES {
		return CHARTSTYPES;
	}

	subscriptions$: Subscription[] = [];
	set sub(s: Subscription) {
		this.subscriptions$.push(s);
	}

	constructor(private translateService: TranslateService, public formioLoader: FormioLoader) {
		this.changeDirection(this.translateService.currentLang);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (
			changes &&
			changes.data &&
			!_isEmpty(changes.data.currentValue) &&
			!_isEqual(changes.data.currentValue, changes.data.previousValue)
		) {
			if (
				this.customOptions &&
				this.customOptions.chartData &&
				this.customOptions.chartData.length
			) {
				this.addDelay = this.customOptions?.addDelay;
				this.chartType = this.customOptions.chartType;
				this.chartLabels = this.customOptions.labels;
				this.fillPieChart();
			} else {
				this.formioLoader.loading = false;
			}
		}
	}

	ngAfterViewInit(): void {
		this.sub = this.translateService.onLangChange.subscribe((data) => {
			this.changeDirection(data.lang);
		});
	}

	private changeDirection(lang) {
		this.dir = null;
		setTimeout(() => {
			this.dir = lang == 'ar' ? 'rtl' : 'ltr';
		});
	}

	fillPieChart() {
		this.chartData = {
			labels: this.chartLabels.map((q) => this.translateService.instant(q)),
			datasets: [
				{
					data: this.customOptions?.chartData,
					backgroundColor: this.customOptions?.backgroundColor,
					hoverBackgroundColor: this.customOptions?.hoverBackgroundColor,
				},
			],
		};

		setTimeout(
			() => {
				this.show = true;
			},
			this.addDelay ? 400 : 0
		);
	}

	ngOnDestroy() {
		this.subscriptions$.forEach((o) => o.unsubscribe());
		this.subscriptions$ = [];
	}
}
